<template>
<div
	class="main-header-page pl-5 media-print"
	:style="`border-bottom: 2px solid ${$appColors.success};`"
>
	<h1 class="header-page-title">{{ title }}</h1>
	<div class="header-page-actions"
		v-if="toShow">
		<v-btn
			v-if="exportToPdf"
			@click.prevent="downloadDispatch"
			class="header-page-download-document primary mr-2">
			<img :src="`${$imageUrl}/icon-export-pdf.svg`" alt="" class="align-img">
		</v-btn>
		<v-btn
			v-if="showExcel"
			class="header-page-download-document primary"
			@click="downloadDocument">
			<img :src="`${$imageUrl}/fill-1.svg`" alt="download" height="17">
		</v-btn>
		<v-btn
			dark
			class="btn-action"
			v-if="showClean"
			@click="$emit('on-clean')"
		>
			Limpiar
		</v-btn>
		<slot></slot>
	</div>
	<div class="header-page-actions translate"
		v-if="quotation || sale">
		<v-btn
			flat
			class="header-page-download-document"
			@click="downloadDocument">
			<img :src="`${$imageUrl}/download.svg`" alt="download" height="17">
		</v-btn>
		<v-btn
			flat
			class="header-page-download-document"
			@click="print">
			<img :src="`${$imageUrl}/print.svg`" alt="download" height="17">
		</v-btn>
	</div>
</div>
</template>

<script>
function columnsToExport() {
	const columnsSelected = this.columns.filter(column => column.visible
		&& !column.flagVisible);
	const newColumns = columnsSelected.map((col) => {
		const newCol = Object.assign({}, col);
		delete newCol.id;
		delete newCol.visible;
		delete newCol.checked;
		return newCol;
	});
	return newColumns;
}

function dataToExport() {
	let tableDataToExport = [];
	const columnsSelected = this.columns.filter(column => column.visible
		&& !column.flagVisible);
	const columnsValues = columnsSelected.map((colVal) => {
		const newColVal = Object.assign({}, colVal);
		return newColVal.value;
	});
	if (this.rows.length > 0) {
		tableDataToExport = this.rows.map((dataExport) => {
			const newData = Object.assign({}, dataExport);
			const keysData = Object.keys(dataExport);
			keysData.forEach((keyData) => {
				if (columnsValues.every(keyCol => keyCol !== keyData)) {
					delete newData[keyData];
				}
			});
			return newData;
		});
	}
	return tableDataToExport;
}

function downloadDispatch() {
	this.$emit('download-dispatch');
}

function downloadDocument() {
	this.exportTable(this.columnsToExport, this.dataToExport, this.name);
}

function print() {
	window.print();
}

export default {
	name: 'header-page',
	computed: {
		columnsToExport,
		dataToExport,
	},
	methods: {
		downloadDispatch,
		downloadDocument,
		print,
	},
	props: {
		columns: {
			type: Array,
		},
		exportToPdf: {
			default: false,
			type: Boolean,
		},
		name: {
			type: String,
		},
		rows: {
			type: Array,
		},
		showClean: {
			default: true,
			type: Boolean,
		},
		showExcel: {
			default: true,
			type: Boolean,
		},
		title: {
			type: String,
			required: true,
		},
		toShow: {
			default: false,
			type: Boolean,
		},
		quotation: {
			default: false,
			type: Boolean,
		},
		sale: {
			default: false,
			type: Boolean,
		},
	},
};
</script>

<style lang="scss" scoped>
.main-header-page {
	@include flex-space-between;
	background-color: white;
	flex-wrap: wrap;
	min-height: 52px;
	width: 100%;

	.header-page-title {
		color: map-get($colors, paginationText);
		font-family: map-get($fonts, open-semibold);
		font-size: map-get($sizes, large);
		margin: 0px;
	}
	.header-page-actions {
		@include flex-space-between;
		margin-left: 40px;
		.btn {
			@include txt-config (open-semibold, small10);
			background-color: map-get($colors, orange-btn);
			border-radius: 5px;
			color: white;
			height: 25px;
			min-width: 58px;
			text-transform: capitalize;
		}
		.header-page-download-document {
			@include flex-center;
			min-width: 25px;
			margin: 0px;
		}
	}
}
.translate {
	transform: translateX(-200px);
	display: grid !important;
	grid-template-columns: 20px 20px;
	grid-column-gap: 20px;
}
</style>





// WEBPACK FOOTER //
// src/components/shared/header-page.vue